import PermissionRoute from '@Src/_basic/helpers/PermissionRoute';
import { RouteConfig } from '@Src/app/BasicRouter';
import React, { memo } from 'react';
import ThirdPartyAccountCreateCardScreen from './screens/ThirdPartyAccountCreateCardScreen';
import ThirdPartyAccountManagementCardScreen from './screens/ThirdPartyAccountManagementCardScreen';
import ThirdPartyAccountUpdateCardScreen from './screens/ThirdPartyAccountUpdateCardScreen';

const routesConfig: RouteConfig[] = [
  {
    path: '/',
    element: <ThirdPartyAccountManagementCardScreen />,
  },
  {
    path: '/ThirdPartyAccountCreate/*',
    element: <ThirdPartyAccountCreateCardScreen />,
  },
  {
    path: '/ThirdPartyAccountUpdate/:id',
    element: <ThirdPartyAccountUpdateCardScreen />,
  },
];

const ThirdPartyAccountManagementRouter = () => PermissionRoute(routesConfig);

export default memo(ThirdPartyAccountManagementRouter);
